import React, { useRef } from 'react';

const Index = () => {

    const aboutSectionRef = useRef(null);

    const scrollToSection = () => {
        if (aboutSectionRef.current) {
          aboutSectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      };
  return (
    <>
      <section className="slick-slideshow mt-5">
        <div className="slick-custom">
          <img
            src="images/slideshow/RealLove.jpg"
            className="img-fluid"
            alt=""
          />
          <div className="slick-bottom">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-10">
                  <h1 className="slick-title">मराठी परिचय-पत्रक</h1>

                  <p className="lead text-white mt-lg-3 mb-lg-5">
                    विवाह इच्छुक मुला-मुलींसाठी मराठी मध्ये बायोडेटा बनवण्याच्या
                    सोयी-साठी
                  </p>

                  <a href="javascript:void(0);" className="btn custom-btn" onClick={scrollToSection}>
                    Learn more about us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="slick-custom">
          <img
            src="images/slideshow/team-meeting-renewable-energy-project.jpeg"
            className="img-fluid"
            alt=""
          />

          <div className="slick-bottom">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-10">
                  <h1 className="slick-title">New Design</h1>

                  <p className="lead text-white mt-lg-3 mb-lg-5">
                    Please share this Little Fashion template to your friends.
                    Thank you for supporting us.
                  </p>

                  <a href="product.html" className="btn custom-btn">
                    Explore products
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="slick-custom">
          <img
            src="images/slideshow/two-business-partners-working-together-office-computer.jpeg"
            className="img-fluid"
            alt=""
          />

          <div className="slick-bottom">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-10">
                  <h1 className="slick-title">Talk to us</h1>

                  <p className="lead text-white mt-lg-3 mb-lg-5">
                    Tooplate is one of the best HTML CSS template websites for
                    everyone.
                  </p>

                  <a href="contact.html" className="btn custom-btn">
                    Work with us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section  ref={aboutSectionRef} className="about section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="mb-5">
                मराठी <span>परिचय पत्रकासाठी</span> सुरुवात करूया
              </h2>
            </div>

            <div className="col-lg-2 col-12 mt-auto mb-auto">
              <ul
                className="nav nav-pills mb-5 mx-auto justify-content-center align-items-center"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    परिचय
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-youtube-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-youtube"
                    type="button"
                    role="tab"
                    aria-controls="pills-youtube"
                    aria-selected="true"
                  >
                    आम्ही कसे काम करतो?
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-skill-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-skill"
                    type="button"
                    role="tab"
                    aria-controls="pills-skill"
                    aria-selected="false"
                  >
                    आमची क्षमता
                  </button>
                </li>
              </ul>
            </div>

            <div className="col-lg-10 col-12">
              <div className="tab-content mt-2" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div className="row">
                    <div className="col-lg-7 col-12">
                      <img
                        src="images/img13.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>

                    <div className="col-lg-5 col-12">
                      <div
                        className="d-flex flex-column h-100 ms-lg-4 mt-lg-0 mt-5 p-3"
                        style={{ background: "rgba(252, 247, 252,0.3)" }}
                      >
                        <h4 className="mb-3">
                          सर्वोत्तम व दर्जेदार टेम्प्लेट्स
                        </h4>

                        {/* <p>Little Fashion templates comes with <a href="sign-in.html">sign in</a> / <a href="sign-up.html">sign up</a> pages, product listing / product detail, about, FAQs, and contact page.</p>

                                                <p>Since this HTML template is based on Boostrap 5 CSS library, you can feel free to add more components as you need.</p> */}
                        <p className="text-dark">
                          नमस्कार, आपण एक वेबसाइटवर आले आहात जे आपल्याला मराठी
                          विवाह बायोडाटा तयार करण्यास मदत करेल. आमच्या वेबसाइटचे
                          उद्देश आहे:
                        </p>

                        <ul className="text-dark">
                          <li>
                            <p>
                              आपल्याला एक उपयोगकर्ता-अनुकूल वेबसाइट पुरविणे जे
                              आपल्याला सुखद ब्राउझिंग अनुभव देईल.
                            </p>
                          </li>
                          <li>
                            <p>
                              मराठी विवाह बायोडाटा तयार करण्यासाठी विविध
                              प्रकारचे पर्याय आणि जास्तीत जास्त कस्टमायझेशन
                              वैशिष्ट्ये पुरविणे.
                            </p>
                          </li>
                          <li>
                            <p>
                              मराठी भाषिकांसाठी विशेषतः तयार केलेला एक निरंतर
                              प्रक्रिया अवलंबून आपल्याला आपल्या मातृभाषेत व्यक्त
                              करण्याची संधी देणे.
                            </p>
                          </li>
                        </ul>
                        {/* <div className="mt-2 mt-lg-auto">
                                                    <a href="about.html" className="custom-link mb-2">
                                                        Learn more about us
                                                        <i className="bi-arrow-right ms-2"></i>
                                                    </a>
                                                </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="pills-youtube"
                  role="tabpanel"
                  aria-labelledby="pills-youtube-tab"
                >
                  <div className="row">
                    <div className="col-lg-7 col-12">
                      <div className="ratio ratio-16x9">
                        <iframe
                          src="https://www.youtube-nocookie.com/embed/IkNTG7N_Eo8?controls=0"
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>

                    <div className="col-lg-5 col-12">
                      <div className="d-flex flex-column h-100 ms-lg-4 mt-lg-0 mt-5">
                        <h4 className="mb-3">Life at Studio</h4>

                        <p>
                          Over three years in business, We’ve had the chance to
                          work on a variety of projects, with companies
                        </p>

                        <p>Custom work is branding, web design, UI/UX design</p>

                        <div className="mt-2 mt-lg-auto">
                          <a href="contact.html" className="custom-link mb-2">
                            Work with us
                            <i className="bi-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="pills-skill"
                  role="tabpanel"
                  aria-labelledby="pills-skill-tab"
                >
                  <div className="row">
                    <div className="col-lg-7 col-12">
                      <img
                        src="images/cody-lannom-G95AReIh_Ko-unsplash.jpeg"
                        className="img-fluid"
                        alt=""
                      />
                    </div>

                    <div className="col-lg-5 col-12">
                      <div className="d-flex flex-column h-100 ms-lg-4 mt-lg-0 mt-5">
                        <h4 className="mb-3">आम्ही आपली कशी मदत करू शकतो ?</h4>

                        <p>
                          मागील एक वर्षांपासून शेकडो लोकांची मदत केल्याचा अभिमान
                          आहे आम्हाला.
                        </p>

                        <div className="skill-thumb mt-3">
                          <strong>Visits</strong>
                          <span className="float-end">10000</span>
                          <div className="progress">
                            <div
                              className="progress-bar progress-bar-primary"
                              role="progressbar"
                              aria-valuenow="90"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              style={{ width: "90%" }}
                            ></div>
                          </div>

                          <strong>Reviews</strong>
                          <span className="float-end">120</span>
                          <div className="progress">
                            <div
                              className="progress-bar progress-bar-primary"
                              role="progressbar"
                              aria-valuenow="70"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              style={{ width: "70%" }}
                            ></div>
                          </div>

                          <strong>Served count</strong>
                          <span className="float-end">250</span>
                          <div className="progress">
                            <div
                              className="progress-bar progress-bar-primary"
                              role="progressbar"
                              aria-valuenow="80"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              style={{ width: "80%" }}
                            ></div>
                          </div>
                        </div>

                        <div className="mt-2 mt-lg-auto">
                          <a href="#" className="custom-link mb-2">
                            Explore products
                            <i className="bi-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="front-product">
        <div className="container-fluid p-0">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-6 col-12 px-5">
              <img
                src="images/1Designer.png"
                className="img-fluid"
                alt=""
                style={{ height: 650, width: 850 }}
              />
            </div>

            <div className="col-lg-6 col-12">
              <div className="px-5 py-5 py-lg-0">
                <h2 className="mb-4">
                  काय आम्ही <span>सादर</span> करत आहोत ?
                </h2>

                {/* <p className="lead mb-4">Credits go to Unsplash and FreePik websites for images used in this Little Fashion by Tooplate.</p> */}
                <p className="lead mb-4">
                  आपण आपला विवाह बायोडाटा PDF किंवा इमेज स्वरूपात तयार करू शकता.
                  आपण आपल्या बायोडाटात आपल्या व्यक्तिमत्व, शैक्षणिक, पेशा,
                  कुटुंब, आणि इतर माहिती जोडू शकता. आपण आपल्या बायोडाटाचा
                  फॉर्मॅट, फॉन्ट, रंग, आणि इमेजेस निवडू शकता. आमच्या वेबसाइटवर
                  आपल्याला अनेक आकर्षक आणि पेशेवर टेम्पलेट्स मिळतील.
                </p>
                {/* <a href="products.html" className="custom-link">
                                    Explore Products
                                    <i className="bi-arrow-right ms-2"></i>
                                </a> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="featured-product section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="mb-5">Featured Products</h2>
            </div>

            <div className="col-lg-4 col-12 mb-3">
              <div className="product-thumb">
                <a href="/form">
                  <img
                    src="images/product/biodata.jpg"
                    className="img-fluid product-image"
                    alt=""
                  />
                </a>

                <div className="product-top d-flex">
                  <span className="product-alert me-auto">New Arrival</span>

                  <a href="#" className="bi-heart-fill product-icon"></a>
                </div>

                <div className="product-info d-flex">
                  <div>
                    <h5 className="product-title mb-0">
                      <a href="/form" className="product-title-link">
                        Marriage Biodata
                      </a>
                    </h5>

                    <p className="product-p">Original design </p>
                  </div>

                  <small className="product-price text-muted ms-auto mt-auto mb-5">
                    Free
                  </small>
                </div>
              </div>
            </div>

            {/* <div className="col-lg-4 col-12 mb-3">
                            <div className="product-thumb">
                                <a href="/form">
                                    <img src="images/product/jordan-nix-CkCUvwMXAac-unsplash.jpeg" className="img-fluid product-image" alt="" />
                                </a>

                                <div className="product-top d-flex">
                                    <span className="product-alert">Low Price</span>

                                    <a href="#" className="bi-heart-fill product-icon ms-auto"></a>
                                </div>

                                <div className="product-info d-flex">
                                    <div>
                                        <h5 className="product-title mb-0">
                                            <a href="/form" className="product-title-link">Fashion Set</a>
                                        </h5>

                                        <p className="product-p">Costume Package</p>
                                    </div>

                                    <small className="product-price text-muted ms-auto mt-auto mb-5">$35</small>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-12">
                            <div className="product-thumb">
                                <a href="/form">
                                    <img src="images/product/nature-zen-3Dn1BZZv3m8-unsplash.jpeg" className="img-fluid product-image" alt="" />
                                </a>

                                <div className="product-top d-flex">
                                    <a href="#" className="bi-heart-fill product-icon ms-auto"></a>
                                </div>

                                <div className="product-info d-flex">
                                    <div>
                                        <h5 className="product-title mb-0">
                                            <a href="/form" className="product-title-link">Juice Drinks</a>
                                        </h5>

                                        <p className="product-p">Nature made another world</p>
                                    </div>

                                    <small className="product-price text-muted ms-auto mt-auto mb-5">$45</small>
                                </div>
                            </div>
                        </div> */}

            {/* <div className="col-12 text-center">
              <a href="/" className="view-all">
                View All Products
              </a>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};
export default Index;
